import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import Ps from 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import classNames from 'classnames';
export default class MessageBox extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const {
      isOverflow,
    } = this.props;
    if (isOverflow) {
      Ps.initialize(this.refs.Message);
    }
  }
  componentWillUnmount() {
    const {
      isOverflow,
    } = this.props;
    if (isOverflow) {
      Ps.initialize(this.refs.Message);
    }
  }
  render() {
    const {
      title,
      onClose,
      width,
      height,
      isOverflow,
    } = this.props;
    const maxHeight = this.props.maxHeight === 'initial' ? 'initial' : `${this.props.maxHeight}px`;
    return (
      <div className="Message-container" style={{ overflow: 'initial' }}>
        <div
          className={classNames('Message', { 'Message_overflow': isOverflow })}
          ref="Message"
          style={
            {
              width: width ? width : 600,
              height: height ? height : 'auto',
            }
          }
        >
          <div className="Message-title">
            <h1 className="Message-title-h1">{title}</h1>
            <button className="btn Message-title-button" onClick={onClose} type="button" style={{ color: '#fff' }}>
              <span className="fa-stack fa-lg">
                <i className="fa fa-circle fa-stack-1x fa-inverse Message_inverse" style={{ opacity: '0.5', fontSize: '1.2em' }}></i>
                <i className="fa fa-circle fa-stack-1x" style={{ opacity: '0.5' }}></i>
                <i className="fa fa-times fa-stack-1x" style={{ color: '#157FCC', fontSize: '0.59em' }}></i>
              </span>
            </button>
          </div>
          <div className="new-Message-body" style={{ overflow: this.props.overflow ? 'auto' : 'initial', maxHeight }}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

MessageBox.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  children: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  isOverflow: PropTypes.bool,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  overflow: PropTypes.bool,
};
MessageBox.defaultProps = {
  isOverflow: false,
  maxHeight: 'initial',
  overflow: false,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/components/MessageBox/index.js
 **/